export function buildQmsQuizListTourSteps() {
  return [
    {
      id: "welcome",
      placement: "center",
      title: "Quiz list",
      body: "This screen lists all quizzes in your organisation. Create quizzes here, then bind them to documents when publishing from My Vault.",
    },
    {
      id: "toolbar",
      target: '[data-tour="qms-quiz-list-toolbar"]',
      placement: "bottom",
      title: "Actions",
      body: "Refresh reloads the list. Add quiz opens the full-screen builder where you assign questions from question master.",
    },
    {
      id: "table",
      target: '[data-tour="qms-quiz-list-table"]',
      placement: "top",
      title: "Quiz table",
      body: "Each row shows pass %, mapped questions, serve count, and document bindings. Edit and delete are in the Actions column.",
    },
    {
      id: "bindings",
      target: '[data-tour="qms-quiz-list-table"]',
      placement: "top",
      title: "Document bindings",
      body: "When Document bindings is greater than 0, the quiz is linked to a published document. Bound quizzes cannot be edited or deleted — this protects staff who already passed or acknowledged.",
    },
    {
      id: "guide",
      target: '[data-tour="qms-quiz-list-guide"]',
      placement: "bottom",
      title: "Page guide",
      body: "Use Guide anytime to replay this tour. The Add quiz popup has its own guide inside the builder.",
    },
    {
      id: "done",
      placement: "center",
      title: "You are ready",
      body: "Add a quiz, assign questions, then bind it during document publish. Switch to Question master tab to manage the question bank first.",
    },
  ];
}
